import { getV2UsersMeSchedulesSelector } from "./getV2UsersMeSchedulesSelector";
import { RootState } from "../../../store";
import { Schedule2 } from "../../../../services/cloudchipr.api";

export const workflowsDataSelector = (
  state: RootState,
): Schedule2[] | undefined => {
  return getV2UsersMeSchedulesSelector(state)?.data;
};
